function normalizedWords(text: string): string[] {
  return text.trim().split(/\s+/u).map(word => word.toLocaleLowerCase("ru-RU").replace(/ё/gu, "е").replace(/[^\p{L}\p{N}]/gu, "")).filter(Boolean);
}

export function mergeVoiceTranscript(current: string, incoming: string): string {
  const left = current.trim();
  const right = incoming.trim();
  if (!left) return right;
  if (!right) return left;

  const leftWords = normalizedWords(left);
  const rightWords = normalizedWords(right);
  const leftKey = leftWords.join(" ");
  const rightKey = rightWords.join(" ");
  if (leftKey === rightKey || leftKey.endsWith(rightKey)) return left;
  if (rightKey.startsWith(leftKey)) return right;

  const rightOriginalWords = right.split(/\s+/u);
  const maxOverlap = Math.min(leftWords.length, rightWords.length);
  for (let size = maxOverlap; size > 0; size -= 1) {
    const leftTail = leftWords.slice(-size).join(" ");
    const rightHead = rightWords.slice(0, size).join(" ");
    if (leftTail === rightHead) return `${left} ${rightOriginalWords.slice(size).join(" ")}`.trim();
  }
  return `${left} ${right}`;
}
